<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <div>
      <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>
         <!-- Code added -->
          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">
          <!-- <b-row class="col-md-12 lgtypelist mt-3">
                 
            <div class="col mx-1">
              <label>Gender</label>
                <b-form-group>
                  <b-form-select @change="showCollection(brand_id, selected_segment_id)"
                    v-model="selected_segment_id"
                    id="selected_segment_id"
                    name="selected_segment_id"
                    placement="Select Gender"
                  >
                    <option :value="null">--Select Gender--</option>
                    <option v-for="segmentlist in segmentarray_list" :value="segmentlist.segment_id" :key="segmentlist.segment_id">{{
                      segmentlist.segment_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div> 
            <div class="col mx-1">
              <label>Season</label>
               <b-form-group >
                  <b-form-select @change="showSubcategory(selected_collection_id)"
                    v-model="selected_collection_id"
                    id="selected_collection_id"
                    name="selected_collection_id"
                  >
                    <option :value="null">--Select Season--</option>
                    <option v-for="collection in collectionData" :value="collection.collection_id" :key="collection.collection_id">{{
                      collection.collection_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div> 

            <div class="col mx-1">
              <label>Sub-category</label>
                 <b-form-group >
                  <b-form-select @change="getPoTypeList(sub_catid);"
                    v-model="sub_catid"
                    id="sub_catid"
                    name="sub_catid"
                  >
                    <option :value="null">--Select Sub-category--</option>
                    <option v-for="subcatarry in sub_cat_id_arr" :value="subcatarry.sub_catid" :key="subcatarry.sub_catid">{{
                      subcatarry.sub_cattitle
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div>

             <div class="col mx-1">
              <label>PO Type (PT)</label>
                <b-form-group >
                
                  <b-form-select
                    v-model="selected_po_id"
                    id="selected_po_id"
                    name="selected_po_id"
                  >
                    <option :value="null">--Select PO Type--</option>
                    <option v-for="polist in po_typearr" :value="polist.po_id" :key="polist.po_id">{{
                      polist.potype_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div> 
            
            <div class="col mx-1">
              <label></label>
              <b-form-group>
               <b-button @click="searchData(brand_id)"
                      type="submit"
                      variant="primary"
                      class="px-4 pull-left mt-2"
                      >Search</b-button
                    >
                  <button
                    class="btn btn-sm btn-primary ml-3 mt-2 px-3 pb-2"
                    v-on:click="refresh()"
                    type="button"
                  >
                    <i class="fa fa-refresh"></i>
                  </button>
                </b-form-group>
            </div> 
 
          </b-row> -->

          <b-row class="col-md-12 lgtypelist mt-3">
                 
                 <div class="col mx-1">
     
                   <b-input-group class="mt-2">
                                 
                     <ejs-multiselect
                       id="selected_segment_id"
                       placeholder="Select Segment"
                       v-model="selected_segment_id"
                       name="selected_segment_id"
                       :fields="segementid_fields"
                       :dataSource="segmentarray_list"
                       :showSelectAll="true"
                       :class="{ input: true }"
                     >
                     </ejs-multiselect>
                   </b-input-group>
     
                   <!-- <label>Gender</label>
                     <b-form-group>
                       <b-form-select @change="showCollection(brand_id, selected_segment_id)"
                         v-model="selected_segment_id"
                         id="selected_segment_id"
                         name="selected_segment_id"
                         placement="Select Gender"
                       >
                         <option :value="null">--Select Gender--</option>
                         <option v-for="segmentlist in segmentarray_list" :value="segmentlist.segment_id" :key="segmentlist.segment_id">{{
                           segmentlist.seg_name
                         }}</option>
                       </b-form-select>
                     </b-form-group> -->
                 </div> 
                 <div class="col mx-1">
                   <b-input-group class="mt-2">
                                 
                     <ejs-multiselect
                       id="selected_collection_id"
                       placeholder="Select Season"
                       v-model="selected_collection_id"
                       name="selected_collection_id"
                       :fields="collectionid_fields"
                       :dataSource="collectionData"
                       :showSelectAll="true"
                       :class="{ input: true }"
                     >
                     </ejs-multiselect>
                   </b-input-group>
                   <!-- <label>Season</label>
                    <b-form-group >
                       <b-form-select @change="showSubcategory(selected_collection_id)"
                         v-model="selected_collection_id"
                         id="selected_collection_id"
                         name="selected_collection_id"
                       >
                         <option :value="null">--Select Season--</option>
                         <option v-for="collection in collectionData" :value="collection.collection_id" :key="collection.collection_id">{{
                           collection.collection_title
                         }}</option>
                       </b-form-select>
                     </b-form-group> -->
                 </div> 
                 <div class="col mx-1">
     
                   <b-input-group class="mt-2">
                                 
                     <ejs-multiselect
                       id="sub_catid"
                       placeholder="Select Sub-Category"
                       v-model="sub_catid"
                       name="sub_catid"
                       :fields="subcatid_fields"
                       :dataSource="sub_cat_id_arr"
                       :showSelectAll="true"
                       :class="{ input: true }"
                     >
                     </ejs-multiselect>
                   </b-input-group>
     
                   <!-- <label>Sub-category</label>
                      <b-form-group >
                       <b-form-select @change="getPoTypeList(sub_catid);"
                         v-model="sub_catid"
                         id="sub_catid"
                         name="sub_catid"
                       >
                         <option :value="null">--Select Sub-category--</option>
                         <option v-for="subcatarry in sub_cat_id_arr" :value="subcatarry.sub_catid" :key="subcatarry.sub_catid">{{
                           subcatarry.sub_cattitle
                         }}</option>
                       </b-form-select>
                     </b-form-group> -->
                 </div>
                  <div class="col mx-1">
                   <b-input-group class="mt-2">
                                 
                     <ejs-multiselect
                       id="selected_po_id"
                       placeholder="Select PO Id"
                       v-model="selected_po_id"
                       name="selected_po_id"
                       :fields="poid_fields"
                       :dataSource="po_typearr"
                       :showSelectAll="true"
                       :class="{ input: true }"
                     >
                     </ejs-multiselect>
                   </b-input-group>
                   <!-- <label>PO Type (PT)</label>
                     <b-form-group >
                     
                       <b-form-select
                         v-model="selected_po_id"
                         id="selected_po_id"
                         name="selected_po_id"
                       >
                         <option :value="null">--Select PO Type--</option>
                         <option v-for="polist in po_typearr" :value="polist.po_id" :key="polist.po_id">{{
                           polist.potype_title
                         }}</option>
                       </b-form-select>
                     </b-form-group> -->
                 </div> 
                 <div class="col mx-1">
                   <label></label>
                   <b-form-group>
                    <b-button @click="searchData(brand_id)"
                           type="submit"
                           variant="primary"
                           class="px-4 pull-left"
                           >Search</b-button
                         >
                       <button
                         class="btn btn-sm btn-primary ml-3 px-3 pb-2"
                         v-on:click="refresh()"
                         type="button"
                       >
                         <i class="fa fa-refresh"></i>
                       </button>
                     </b-form-group>
                 </div> 
      
               </b-row>
               
          <hr>
          <div v-if="this.user_type_data == 'Junior_Buyer'">
            <label style="margin-left: 20px;">All Designs : </label>         
            <b-row class="boxto">     
       

                <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua" >
                 <router-link  :to="'/style_list/' +'ALL_Designs'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{ALL_Designs}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="My Designs"> All Designs</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
            </b-row>
            <hr style="height:30px">
          </div>

            <label style="margin-left: 20px;" class="mt-2">Design Styles : </label>         
            <b-row class="boxto"> 
              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def"  >
                <router-link  :to="'/style_list/' +'Designs_Approved'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs pending for approval">{{Designs_Approved}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Designs Pending for approval"> Pending for Grading</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>


              <!-- <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green" >
                <router-link  :to="'/style_list/' +'Designs_Rejected'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Designs_Rejected}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Designs rejected</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col> -->

              <!-- <b-col sm="6" lg="2" >
                <b-card no-body class="bg-pink" >
                <router-link  :to="'/style_list/' +'Designs_Feedback'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Designs_Feedback}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Designs Feedback</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col> -->
             
            
            
            </b-row>
            <hr style="height:30px">


              <!-- Code For Files -->

            <label style="margin-left: 20px;">Files : </label>         
            <b-row class="boxto">     
            <b-col sm="6" lg="2" >

                <b-card no-body class="bg-aqua"  >
                    <router-link :to="'/style_list/' + 'Tech_Pack_Uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">{{Tech_Pack_Uploaded}} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">Tech Pack Uploaded</p>
                  </b-card-body>
                   </router-link>   


                </b-card>
              </b-col>
                    <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal"  >
                <router-link  :to="'/style_list/' +'BOM_Uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs approve)">{{BOM_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Designs approved"> BOM Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>


              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def" >
                <router-link  :to="'/style_list/' +'Measurment_Chart_Uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Measurment_Chart_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Measurement Chart Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green"  >
                <router-link  :to="'/style_list/' +'All_Files_Uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="All Files Uploaded)">{{All_Files_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Designs approved"> All Files Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
            
            </b-row>
            <hr style="height:30px">


              <!-- Code added -->
           <label style="margin-left: 20px;">Quotations:</label>         
            <b-row class="boxto">  

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua" >
                <router-link  :to="'/style_list/' +'Quotation_pending'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="In quotation">{{Quotation_pending}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="In quotation">Quotation pending</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

       
                   <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal"  >
                <router-link  :to="'/style_list/' +'In_Quotation'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Quotation pending)">{{In_Quotation}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Quotation pending">In quotation</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

           

              <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-def" >
                  <router-link  :to="'/style_list/' +'Quotation_received'">
                      <b-card-body class="pb-0">  
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Quotation received">{{Quotation_received}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor " v-b-tooltip.hover title="Quotation received">Quotation received</p>
                  </b-card-body>   
                  </router-link>     
                </b-card>
              </b-col>

               <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green" >
                  <router-link  :to="'/style_list/' +'Quotation_approved'">
                  <b-card-body class="pb-0">
                            
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title=" Quotation approved">{{Quotation_approved}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Quotation approved">Quotation approved</p>
                  </b-card-body>
                   </router-link>            
                </b-card>
              </b-col>   

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-pink" >
                  <router-link  :to="'/style_list/' +'Quotation_rejected'">
                  <b-card-body class="pb-0">
                            
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title=" Quotation Rejected">{{Quotation_rejected}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Quotation Rejected">Quotation Rejected</p>
                  </b-card-body>
                   </router-link>            
                </b-card>
              </b-col>
             
             </b-row>
             <hr style="height:30px">


            <label style="padding-top: 10px!important; margin-left: 20px;">Sampling</label><br/>
            <label style="margin-left: 20px;">Proto Sampling :</label>                 
            <b-row class="boxto"> 
              
                <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-aqua" >
                        <router-link  :to="'/style_list/' +'proto_sampling_pending'">
                        <b-card-body class="pb-0">          
                          <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling pendin)" >{{proto_sampling_pending}}</h4>
                          <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Proto Sampling pending">Proto Sampling pending</p>
                        </b-card-body> 
                        </router-link>       
                      </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal" >
                      <router-link  :to="'/style_list/' +'proto_sampling_rejected'">
                      <b-card-body class="pb-0">          
                        <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling requested" >{{proto_sampling_rejected}}</h4>
                        <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Proto Sampling requested">Proto Sampling Rejected</p>
                      </b-card-body> 
                      </router-link>       
                    </b-card>
                </b-col>
                      
                <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-def" >
                      <router-link  :to="'/style_list/' +'proto_sampling_approved'">
                      <b-card-body class="pb-0">          
                        <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling approved" >{{proto_sampling_approved}}</h4>
                        <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Proto Sampling approved">Proto Sampling approved</p>
                      </b-card-body> 
                      </router-link>       
                    </b-card>
                </b-col>


              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal">
                   <router-link  :to="'/style_list/' +'proto_dispatched'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Proto Dispatched">
                    {{proto_dispatched}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="Proto Dispatched"> Proto Dispatched</p>
                  </b-card-body> 
                 </router-link>       
                </b-card>
              </b-col> 
            </b-row>

            <!-- <label style="margin-left: 20px;" class="">PP :</label> 
            <b-row>

              <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-green" >
                  <router-link  :to="'/style_list/' +'pp_pending'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="PP pending" >{{pp_pending}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="PP pending">PP pending</p>
                  </b-card-body> 
                  </router-link>       
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-pink" >
                  <router-link  :to="'/style_list/' +'pp_sampling_requested'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="PP requested" >{{pp_sampling_requested}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="PP requested">PP requested</p>
                  </b-card-body> 
                  </router-link>       
                </b-card>
              </b-col>
               
               
               <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-red">
                  <router-link  :to="'/style_list/' +'pp_approved'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="PP approved">{{pp_approved}}</h4>
                    <p  style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PP approve">PP approved</p>
                  </b-card-body>
                    </router-link>        
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua">
                   <router-link  :to="'/style_list/' +'pp_rejected'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="PO Createdd">
                    {{pp_rejected}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PP Rejected"> PP Rejected</p>
                  </b-card-body> 
                 </router-link>       
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def">
                   <router-link  :to="'/style_list/' +'pp_dispatched'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="PP Dispatched">
                    {{pp_dispatched}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PP Dispatched"> PP Dispatched</p>
                  </b-card-body> 
                 </router-link>       
                </b-card>
              </b-col>
            </b-row> -->

          </b-card>
        </b-col>
        
      </b-row>
     
      
    </div>


    <div >
    
      <b-row>
        <b-col cols="12">
          
        <!--  <b-breadcrumb :items="breadcrumbs"/> -->
         <!-- Code added -->
          <b-card >
           <!-- Code added by Sachin
            Date:12/02/2020 -->

            <hr style="height:30px">    
            
            <label style="padding-top: 10px!important; margin-left: 20px;">TNA</label>
           <b-row class="boxto">     
            <b-col sm="6" lg="2" >
              <b-card no-body class="bg-def" >
                <router-link  :to="'/style_list/' +'tna_uploaded'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="TNA pending)" > {{tna_uploaded}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="TNA pending">TNA Uploaded</p>
                </b-card-body> 
                 </router-link>        
              </b-card>
            </b-col>
            
            <b-col sm="6" lg="2" >
              <b-card no-body class="bg-pink">
                  <router-link  :to="'/style_list/' +'tna_approved'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="TNA approved"> {{tna_approved}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" TNA approved"> TNA Approved</p>
                </b-card-body>
                </router-link>       
              </b-card>
            </b-col>
             <b-col sm="6" lg="2" >
              <b-card no-body class="bg-green">
                <router-link  :to="'/style_list/' +'tna_feedback'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="TNA submitted"> {{tna_feedback}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor " v-b-tooltip.hover title="TNA submitted">TNA Feedback</p>
                </b-card-body>
                 </router-link>               
              </b-card>
            </b-col>   
            <b-col sm="6" lg="2" >
              <b-card no-body class="bg-pink">
                  <router-link  :to="'/style_list/' +'tna_rejected'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="TNA rejected"> {{tna_rejected}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" TNA rejected"> TNA Rejected</p>
                </b-card-body>
                </router-link>       
              </b-card>
            </b-col>  
            <!-- <b-col sm="6" lg="2" >
              <b-card no-body class="bg-pink">
                  <router-link  :to="'/style_list/' +'tna_modified'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="TNA modified"> {{tna_modified}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" TNA modified"> TNA Modified</p>
                </b-card-body>
                </router-link>       
              </b-card>
            </b-col>  -->
            
 
           
         </b-row>


            <hr style="height:30px">

            <label style="padding-top: 10px!important; margin-left: 20px;">PO</label>
              <b-row class="boxto">
                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-aqua">
                    <router-link :to="'/style_list/' + 'PO_Created'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Created"
                        >
                          {{ PO_Created }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Created"
                        >
                          PO Created
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-def">
                    <router-link :to="'/style_list/' + 'PO_Generated'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Generated"
                        >
                          {{ PO_Generated }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Generated"
                        >
                          PO Generated
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-purpal">
                    <router-link :to="'/style_list/' + 'PO_initiated'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Initiated"
                        >
                          {{ PO_initiated }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Initiated"
                        >
                          PO Initiated
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>
              </b-row>
            <!-- Code End -->
            <!-- <strong class="heading">Orders</strong>  -->   
         
          <!-- Code End -->
          <!-- <strong class="heading">Orders</strong>  -->        
      <hr style="height:30px">

        <!-- <label style="padding-top: 10px!important; margin-left: 20px;">Orders</label> -->
   
            <!-- <b-col sm="6" lg="2" class="pointer">
              <b-card no-body class="bg-aqua">
                 <router-link  :to="'/style_list/' +'Order_pending'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Order pendin">
                  {{Order_pending}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="Order pending">Order pending</p>
                </b-card-body> 
                 </router-link>         
              </b-card>
            </b-col>
            
            <b-col sm="6" lg="2" class="pointer">
              <b-card no-body class="bg-purpal">
               <router-link  :to="'/style_list/' +'Order_submitted'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Order submitted"> {{Order_submitted}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="Order submitted">Order submitted</p>
                </b-card-body>
                </b-card-body> 
                 </router-link>             
              </b-card>
            </b-col>
            <b-col sm="6" lg="2" class="pointer">
              <b-card no-body class="bg-def" >
                <router-link  :to="'/style_list/' +'Order_received'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Order received" > {{Order_received}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Order received">Order received</p>
                </b-card-body> 
                 </router-link>       
              </b-card>
            </b-col> -->
            
          </b-card>
        </b-col>
        </b-row>
  
    </div>
  </div>

  </div>

 
           
          
</template>


<script>

import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from "@/utils/auth";
const axios = require('axios');
export default {
  name: 'dashboard_buyingHead',
  data: function () {
    return {
      name: 'dashboard_buyingHead',
      id: '',
      Firstmile:[],
      Lasttmile:[],
      Reverse:[],
     a:-1,
     ALL_Designs: 0,
    pending_for_approval: 0,
    Designapproved:0,
    designrejected: 0,

      inprogress: 0,
      approved: 0,
      pending: 0,
      received: 0,

    BOM_Uploaded: 0,
    Measurment_Chart_Uploaded: 0,
    Tech_Pack_Uploaded: 0,
    All_Files_Uploaded: 0,

     Order_pending: 0,
     Order_received: 0,
     Order_submitted: 0,
      PO_Created: 0,
      PO_Approved:0,
      PO_Updated:0,
    PO_submitted: 0,
    tna_approved: 0,
    tna_rejected: 0,
    tna_modified: 0,
    tna_uploaded: 0,
    tna_feedback: 0,


    proto_sampling_pending: 0,
    proto_sampling_rejected:0,
    proto_sampling_approved:0,
    pp_pending:0,
    pp_sampling_requested:0,
    pp_approved:0,
    pp_rejected:0,
    proto_dispatched: 0,
    pp_dispatched: 0,
    PO_Generated: 0,
    PO_initiated: 0,


    rejected: 0,
      resultData: [],
    
    Designs_Approved : 0,
    Designs_Rejected : 0,
    Designs_Feedback: 0,
    Designs_Pending_For_Approval : 0,
    MY_Designs: 0,
    In_Quotation: 0,
    Quotation_pending :0,
    Quotation_received:0,
    Quotation_approved:0,
    Quotation_rejected:0,
   
    proto_sampling_requested : 0,
   
    pp_sampling_pending : 0,
  
    pp_sampling_approved : 0,
      PO_CreatedPO_submitted: 0,
      PO_UpdatedPO_updated:0,
    TNA_pending : 0,
    TNA_submitted : 0,
    TNA_approved : 0,
    In_Preparation:0,
    In_Production:0,
    Ready_for_Dispatch:0,
  
    user_type_data:'',

    breadcrumbs: [{
        text: 'Dashboard',
        active: true
      }],
      // Search Data
      segmentarray_list: [],
      selected_segment_id: null,
      collectionData: [],
      collection_brand_id: "",
      collection_segment_id: "",
      selected_collection_id: null,
      brand_id: '',
      segment_id: '',
      segmentList_arr: [],
      totalRows: 0,
      // sub_catid: "",
      sub_cat_id_arr: [],
      po_typearr: [],
      sub_catid: null,
      selected_po_id: null,
      result:[],

    }
  },
 
  created: function () {

    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)
    localStorage.setItem('formData', JSON.stringify({}));
   // this.sub_cat_id_arr = userInfo[0].subcat_assign;

    // this.displayDashboardData();
    // this.getBrandSegmentList();

  },
  mounted() {
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)
    let tempLocalStorage = localStorage.filters ? JSON.parse(localStorage.filters) : null
    console.log('tempLocalStorage-------->',tempLocalStorage)
    if(tempLocalStorage){
      if(tempLocalStorage.selected_segment_id){
        this.selected_segment_id = tempLocalStorage.selected_segment_id
        this.showCollection(userInfo[0].brand_assign,tempLocalStorage.selected_segment_id)
        this.selected_collection_id = tempLocalStorage.selected_collection_id
        if(tempLocalStorage.selected_collection_id){
          this.showSubcategory(tempLocalStorage.selected_collection_id)
        }
        this.sub_catid = tempLocalStorage.sub_catid
        if(tempLocalStorage.sub_catid){
          this.getPoTypeList(tempLocalStorage.sub_catid)
        }
        this.selected_po_id = tempLocalStorage.selected_po_id
      }
      
    }
    this.displayDashboardData();
    this.getBrandSegmentList();
  },

  methods: {
    
      displayDashboardData: function () {
         var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)
          this.user_type_data = userInfo[0].user_type
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
      axios.defaults.headers.common['Origin'] = 'http://localhost:8080';

      // if (this.selected_segment_id || this.selected_collection_id || this.sub_catid || this.selected_po_id) {
      //   alert();
      // }
      // else
      // {
        this.Object = {
           user_id:userInfo[0].user_id,
           user_type:userInfo[0].user_type,
          brand_id: userInfo[0].brand_assign   ,
          segment_id: this.selected_segment_id ? this.selected_segment_id : null,
          collection_id: this.selected_collection_id ? this.selected_collection_id : null,
          sub_catid: this.sub_catid ? this.sub_catid : null,
          po_id: this.selected_po_id ? this.selected_po_id : null
        }
      // }
         
        
       // getDashboardCount
        
      axios.post(`${CONSTANTS.API_URL}/getDashboardCountforBuyingHead`,this.Object)
                .then(response => {
                 var result = response.data
                 this.resultData = response.data.returnvalue[0];
                  if (result.returnmsg === 'Successful') {
                  if(this.resultData.All_Designs.ALL_Designs=='' || this.resultData.All_Designs.ALL_Designs==null || this.resultData.All_Designs.ALL_Designs==undefined){
                      this.ALL_Designs= 0;
                    }
                    else{
                      this.ALL_Designs= this.resultData.All_Designs.ALL_Designs
                    }
                    
                  if(this.resultData.Design_Styles.Designs_Pending_For_Approval=='' || this.resultData.Design_Styles.Designs_Pending_For_Approval==null || this.resultData.Design_Styles.Designs_Pending_For_Approval==undefined){
                      this.Designs_Pending_For_Approval= 0;
                    }
                    else{
                      this.Designs_Pending_For_Approval= this.resultData.Design_Styles.Designs_Pending_For_Approval
                    } 

                    if(this.resultData.Design_Styles.MY_Designs=='' || this.resultData.Design_Styles.MY_Designs==null || this.resultData.Design_Styles.MY_Designs==undefined){
                      this.MY_Designs= 0;
                    }
                    else{
                      this.MY_Designs= this.resultData.Design_Styles.MY_Designs
                    }

                   if(this.resultData.Design_Styles.Designs_Approved=='' || this.resultData.Design_Styles.Designs_Approved==null || this.resultData.Design_Styles.Designs_Approved==undefined){
                      this.Designs_Approved= 0;
                    }
                    else{
                      this.Designs_Approved= this.resultData.Design_Styles.Designs_Approved
                    }

                  if(this.resultData.Design_Styles.Designs_Rejected=='' || this.resultData.Design_Styles.Designs_Rejected==null || this.resultData.Design_Styles.Designs_Rejected==undefined){
                      this.Designs_Rejected= 0;
                    }
                  else{
                    this.Designs_Rejected= this.resultData.Design_Styles.Designs_Rejected;
                  }

                  if(this.resultData.Design_Styles.Designs_Feedback=='' || this.resultData.Design_Styles.Designs_Feedback==null || this.resultData.Design_Styles.Designs_Feedback==undefined){
                      this.Designs_Feedback= 0;
                    }
                  else{
                    this.Designs_Feedback= this.resultData.Design_Styles.Designs_Feedback;
                  }

                   if(this.resultData.PO.PO_Generated=='' || this.resultData.PO.PO_Generated==null || this.resultData.PO.PO_Generated==undefined){
                      this.PO_Generated= 0;
                      }
                    else{
                      this.PO_Generated= this.resultData.PO.PO_Generated;
                    }

                    if(this.resultData.PO.PO_initiated=='' || this.resultData.PO.PO_initiated==null || this.resultData.PO.PO_initiated==undefined){
                      this.PO_initiated= 0;
                      }
                    else{
                      this.PO_initiated= this.resultData.PO.PO_initiated;
                    }
      
                  


                  if(this.resultData.Files.BOM_Uploaded=='' || this.resultData.Files.BOM_Uploaded==null || this.resultData.Files.BOM_Uploaded==undefined){
                      this.BOM_Uploaded= 0;
                    }
                    else{
                      this.BOM_Uploaded= this.resultData.Files.BOM_Uploaded
                    }

                    if(this.resultData.Files.Measurment_Chart_Uploaded=='' || this.resultData.Files.Measurment_Chart_Uploaded==null || this.resultData.Files.Measurment_Chart_Uploaded==undefined){
                                  this.Measurment_Chart_Uploaded= 0;
                    }
                    else{
                      this.Measurment_Chart_Uploaded= this.resultData.Files.Measurment_Chart_Uploaded
                    }

                    if(this.resultData.Files.Tech_Pack_Uploaded=='' || this.resultData.Files.Tech_Pack_Uploaded==null || this.resultData.Files.Tech_Pack_Uploaded==undefined){
                                  this.Tech_Pack_Uploaded= 0;
                    }
                    else{
                      this.Tech_Pack_Uploaded= this.resultData.Files.Tech_Pack_Uploaded
                    }

                    if(this.resultData.Files.All_Files_Uploaded=='' || this.resultData.Files.All_Files_Uploaded==null || this.resultData.Files.All_Files_Uploaded==undefined){
                           this.All_Files_Uploaded= 0;
                    }
                    else{
                      this.All_Files_Uploaded= this.resultData.Files.All_Files_Uploaded
                    }


                    if(this.resultData.Quotations.In_Quotation=='' || this.resultData.Quotations.In_Quotation==null || this.resultData.Quotations.In_Quotation==undefined){
                      this.In_Quotation= 0;
                    }
                    else{
                      this.In_Quotation= this.resultData.Quotations.In_Quotation
                    }

                    if(this.resultData.Quotations.Quotation_pending=='' || this.resultData.Quotations.Quotation_pending==null || this.resultData.Quotations.Quotation_pending==undefined){
                                  this.Quotation_pending= 0;
                    }
                    else{
                      this.Quotation_pending= this.resultData.Quotations.Quotation_pending
                    }
                    if(this.resultData.Quotations.Quotation_received=='' || this.resultData.Quotations.Quotation_received==null || this.resultData.Quotations.Quotation_received==undefined){
                                  this.Quotation_received= 0;
                    }
                    else{
                      this.Quotation_received= this.resultData.Quotations.Quotation_received
                    }
                   
                    if(this.resultData.Quotations.Quotation_approved=='' || this.resultData.Quotations.Quotation_approved==null || this.resultData.Quotations.Quotation_approved==undefined){
                                  this.Quotation_approved= 0;
                    }
                    else{
                      this.Quotation_approved= this.resultData.Quotations.Quotation_approved
                    }
                    if(this.resultData.Quotations.Quotation_rejected=='' || this.resultData.Quotations.Quotation_rejected==null || this.resultData.Quotations.Quotation_rejected==undefined){
                                  this.Quotation_rejected= 0;
                    }
                    else{
                      this.Quotation_rejected =this.resultData.Quotations.Quotation_rejected     
                       }
                    


          if(this.resultData.Sampling.proto_sampling_pending=='' || this.resultData.Sampling.proto_sampling_pending==null || this.resultData.Sampling.proto_sampling_pending==undefined){
          this.proto_sampling_pending= 0;
          }
        else{
          this.proto_sampling_pending= this.resultData.Sampling.proto_sampling_pending;
        }

        if(this.resultData.Sampling.proto_sampling_rejected=='' || this.resultData.Sampling.proto_sampling_rejected==null || this.resultData.Sampling.proto_sampling_rejected==undefined){
          this.proto_sampling_rejected= 0;
          }
        else{
          this.proto_sampling_rejected= this.resultData.Sampling.proto_sampling_rejected;
        }

        if(this.resultData.Sampling.proto_sampling_approved=='' || this.resultData.Sampling.proto_sampling_approved==null || this.resultData.Sampling.proto_sampling_approved==undefined){
          this.proto_sampling_approved= 0;
          }
        else{
          this.proto_sampling_approved= this.resultData.Sampling.proto_sampling_approved;
        }

        if(this.resultData.Sampling.pp_pending=='' || this.resultData.Sampling.pp_pending==null || this.resultData.Sampling.pp_pending==undefined){
          this.pp_pending= 0;
          }
        else{
          this.pp_pending= this.resultData.Sampling.pp_pending;
        }

        if(this.resultData.Sampling.pp_sampling_requested=='' || this.resultData.Sampling.pp_sampling_requested==null || this.resultData.Sampling.pp_sampling_requested==undefined){
          this.pp_sampling_requested= 0;
          }
        else{
          this.pp_sampling_requested= this.resultData.Sampling.pp_sampling_requested;
        }

        if(this.resultData.Sampling.pp_approved=='' || this.resultData.Sampling.pp_approved==null || this.resultData.Sampling.pp_approved==undefined){
          this.pp_approved= 0;
          }
        else{
          this.pp_approved= this.resultData.Sampling.pp_approved;
        }
        
        if(this.resultData.Sampling.pp_rejected=='' || this.resultData.Sampling.pp_rejected==null || this.resultData.Sampling.pp_rejected==undefined){
          this.pp_rejected= 0;
          }
        else{
          this.pp_rejected= this.resultData.Sampling.pp_rejected;
        }

        if(this.resultData.Sampling.proto_dispatched=='' || this.resultData.Sampling.proto_dispatched==null || this.resultData.Sampling.proto_dispatched==undefined){
          this.proto_dispatched= 0;
          }
        else{
          this.proto_dispatched= this.resultData.Sampling.proto_dispatched;
        }

        if(this.resultData.Sampling.pp_dispatched=='' || this.resultData.Sampling.pp_dispatched==null || this.resultData.Sampling.pp_dispatched==undefined){
          this.pp_dispatched= 0;
          }
        else{
          this.pp_dispatched= this.resultData.Sampling.pp_dispatched;
        }

        if(this.resultData.PO.PO_Created=='' || this.resultData.PO.PO_Created==null || this.resultData.PO.PO_Created==undefined){
          this.PO_Created= 0;
          }
        else{
          this.PO_Created= this.resultData.PO.PO_Created;
        }
        
        if(this.resultData.PO.PO_Approved=='' || this.resultData.PO.PO_Approved==null || this.resultData.PO.PO_Approved==undefined){
          this.PO_Approved= 0;
          }
        else{
          this.PO_Approved= this.resultData.PO.PO_Approved;
        }

        if(this.resultData.PO.PO_Updated=='' || this.resultData.PO.PO_Updated==null || this.resultData.PO.PO_Updated==undefined){
          this.PO_Updated= 0;
          }
        else{
          this.PO_Updated= this.resultData.PO.PO_Updated;
        }

        if(this.resultData.PO.PO_submitted=='' || this.resultData.PO.PO_submitted==null || this.resultData.PO.PO_submitted==undefined){
          this.PO_submitted= 0;
          }
        else{
          this.PO_submitted= this.resultData.PO.PO_submitted;
        }
        if(this.resultData.PO.In_Preparation=='' || this.resultData.PO.In_Preparation==null || this.resultData.PO.In_Preparation==undefined){
                      this.In_Preparation= 0;
                      }
                    else{
                      this.In_Preparation= this.resultData.PO.In_Preparation;
                    }

                    if(this.resultData.PO.In_Production=='' || this.resultData.PO.In_Production==null || this.resultData.PO.In_Production==undefined){
                      this.In_Production= 0;
                      }
                    else{
                      this.In_Production= this.resultData.PO.In_Production;
                    }

                    if(this.resultData.PO.Ready_for_Dispatch=='' || this.resultData.PO.Ready_for_Dispatch==null || this.resultData.PO.Ready_for_Dispatch==undefined){
                      this.Ready_for_Dispatch= 0;
                      }
                    else{
                      this.Ready_for_Dispatch= this.resultData.PO.Ready_for_Dispatch;
                    }
        if(this.resultData.Tna.tna_uploaded=='' || this.resultData.Tna.tna_uploaded==null || this.resultData.Tna.tna_uploaded==undefined){
          this.tna_uploaded= 0;
          }
        else{
          this.tna_uploaded= this.resultData.Tna.tna_uploaded;
        }

        if(this.resultData.Tna.tna_approved=='' || this.resultData.Tna.tna_approved==null || this.resultData.Tna.tna_approved==undefined){
          this.tna_approved= 0;
          }
        else{
          this.tna_approved= this.resultData.Tna.tna_approved;
        }

        if(this.resultData.Tna.tna_modified=='' || this.resultData.Tna.tna_modified==null || this.resultData.Tna.tna_modified==undefined){
          this.tna_modified= 0;
          }
        else{
          this.tna_modified= this.resultData.Tna.tna_modified;
        }
        

        if(this.resultData.Tna.tna_rejected=='' || this.resultData.Tna.tna_rejected==null || this.resultData.Tna.tna_rejected==undefined){
          this.tna_rejected= 0;
          }
        else{
          this.tna_rejected= this.resultData.Tna.tna_rejected;
        }

        if(this.resultData.Tna.tna_feedback=='' || this.resultData.Tna.tna_feedback==null || this.resultData.Tna.tna_feedback==undefined){
          this.tna_feedback= 0;
          }
        else{
          this.tna_feedback= this.resultData.Tna.tna_feedback;
        }

        if(this.resultData.Orders.Order_pending=='' || this.resultData.Orders.Order_pending==null || this.resultData.Orders.Order_pending==undefined){
          this.Order_pending= 0;
          }
        else{
          this.Order_pending= this.resultData.Orders.Order_pending;
        }

        if(this.resultData.Orders.Order_submitted=='' || this.resultData.Orders.Order_submitted==null || this.resultData.Orders.Order_submitted==undefined){
          this.Order_submitted= 0;
          }
        else{
          this.Order_submitted= this.resultData.Orders.Order_submitted;
        }

        if(this.resultData.Orders.Order_received=='' || this.resultData.Orders.Order_received==null || this.resultData.Orders.Order_received==undefined){
          this.Order_received= 0;
          }
        else{
          this.Order_received= this.resultData.Orders.Order_received;
        }


                  // this.PO_Created= this.resultData.PO.PO_Created
                  // this.PO_submitted= this.resultData.PO.PO_submitted
                  // this.tna_uploaded= this.resultData.Tna.tna_uploaded
                  // this.TNA_submitted= this.resultData.PO.TNA_submitted
                  // this.tna_approved= this.resultData.Tna.tna_approved
                  // this.In_production= this.resultData.PO.In_production

                  // this.Order_pending= this.resultData.Orders.Order_pending
                  // this.Order_submitted= this.resultData.Orders.Order_submitted
                  // this.Order_received= this.resultData.Orders.Order_received
              
     
        }   
        
        })        
    },

    searchData:function(brand_id){
      console.log("selected_segment_id", this.selected_segment_id)
      this.updateFilters();
      this.displayDashboardData(brand_id);
    },

    // Search function api's

        /****** Function to Get Brand & Segments ********/
    getBrandSegmentList:function(){
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;
        if (userInfo[0].user_type == "Brand_Manager") {
          this.selected_brand_manager = userInfo[0].user_id;
        } else {
          this.selected_brand_manager = userInfo[0].brand_manager;
        }
        var obj = {
          user_id: this.user_id,
          selected_brand: this.brand_assign,
          brand_manager: this.selected_brand_manager,
        };

        axios
          .post(`${CONSTANTS.API_URL}/getBrandSegmentList`, obj)
          .then((response) => {
           
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // document.getElementById("overlay").style.display = "none";
              this.segmentarray_list = this.result.returnvalue[0]['segment_list'];
               this.segmentList_arr = this.result.returnvalue;
              this.totalRows = this.segmentList_arr[0]["segment_list"].length;

              if (this.totalRows > 0) {
                this.segment_id = this.segmentList_arr[0]["segment_list"][0][
                  "segment_id"
                ];
                this.brand_id = this.segmentList_arr[0]["segment_list"][0][
                  "brand_id"
                ];
                //this.showCollection(this.brand_id, this.segment_id);
              }

            }
            else{
              this.segmentList_arr = [];
              this.totalRows = 0;
            }
          })
           .catch((e) => {
            this.errors.push(e);
          });

      }
    },

        // Collection list accorfing to segment selected
    showCollection(brand_id, segment_id) {
      // let tempLocalStorage = localStorage.filters ? JSON.parse(localStorage.filters) : {};
      // tempLocalStorage.selected_segment_id = segment_id
      // localStorage.setItem('filters',JSON.stringify(tempLocalStorage))
      // console.log('setting localstorage in selected_segment_id---->',tempLocalStorage)
      this.selected_collection_id=null,
      this.sub_catid=null,
      this.selected_po_id=null,
      this.sub_cat_id_arr = [];
      this.po_typearr = [];

      // document.getElementById("overlay").style.display = "block";
      this.collection_brand_id = brand_id;
      this.collection_segment_id = segment_id;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      var user_id = userInfo[0].user_id;

      const Obj = {
        brand_id: brand_id,
        segment_id: segment_id,
        user_id:  userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getSegmentCollectionList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {

             this.collectionData = response.data.returnvalue.collections;
             console.log("collections");
             console.log(this.collectionData)
          }else{
            this.collectionData = []
          }
        })
         .catch((e) => {
            this.errors.push(e);
          });
    
    },

        /******Function To Get Sub Category List********/

      // Sub Category list accorfing to segment selected
        showSubcategory(collection_id) {
         // this.updateFilters(); 
          this.sub_catid = null,
          this.selected_po_id = null,
          this.po_typearr = [];
          document.getElementById("overlay").style.display = "block";

          const Obj = {
            collection_id,
            user_id:  userInfo[0].user_id,
          };
          axios
            .post(`${CONSTANTS.API_URL}/getSubcategoryForDashboardFilter`, Obj)
            .then((response) => {
              document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                this.sub_cat_id_arr = response.data.returnvalue;
              }else{
                this.sub_cat_id_arr = []
              }
            })
            .catch((e) => {
                this.errors.push(e);
              });
                
        },

        /******Function To Get PO Type List********/
    getPoTypeList: function(subcat_id) {
      this.selected_po_id=null;

      // document.getElementById("overlay").style.display = "block";

      // this.isBusy = true;
      const Obj = {
        subcat_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.po_typearr = this.result.returnvalue;
            // this.totalRows = this.result.returnvalue.length;
            // this.isBusy = !this.isBusy;
          } else {
            this.po_typearr = [];
            // this.totalRows=0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    updateFilters(){
        
        const filters = {
          "selected_segment_id" : this.selected_segment_id,
          "selected_collection_id" : this.selected_collection_id,
          "sub_catid": this.sub_catid,
          "selected_po_id": this.selected_po_id
        };
        localStorage.setItem('filters',JSON.stringify(filters));
        console.log(filters);
        console.log(this.selected_po_id);
      },

    refresh: function () {
      this.collectionData = [];
      this.sub_cat_id_arr = [];
      this.po_typearr = [];
      
      this.selected_segment_id = null,
      this.selected_collection_id = null,
      this.sub_catid = null,
      this.selected_po_id = null,
      localStorage.removeItem('filters');
      this.displayDashboardData();

    },

  }
}

</script>
